<template>
  <div style="padding: 10px; width: 100%">
    <div
      style="
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-top: 20px;
      "
    >
      {{ workDate | formatDate }}<i class="pi pi-calendar"></i>
    </div>
    <div>
      <b>{{ $t("WorkRegistrationForm.OtherTitle") }}</b>
    </div>
    <div v-if="!addTimeManually">
      <div class="row">
        <div
        class="col-6"
        >
          <span>{{ $t("WorkRegistrationForm.StartTime") }}</span>
          <br />
          <label
            ><b>{{
              this.selectedStartTime
                ? moment(selectedStartTime).format("HH:mm")
                : " --:-- "
            }}</b></label
          >
        </div>
        <div
        class="col-6"
        >
          <span>{{ $t("WorkRegistrationForm.EndTime") }}</span>
          <br />
          <label
            ><b>{{
              this.selectedEndTime
                ? moment(selectedEndTime).format("HH:mm")
                : " --:-- "
            }}</b></label
          >
        </div>
      </div>
      <div class="row">
        <div
          class="col-6"
          style="padding: 10px"
        >
          <div class="div-field">
            <button
              :disabled="selectedStartTime"
              class="custom-mobile-button"
              @click="startActivity()"
            >
              {{ $t("WorkRegistrationForm.Start") }}
            </button>
          </div>
        </div>
        <div
          class="col-6"
          style="padding: 10px"
        >
          <div class="div-field">
            <button
              :disabled="selectedEndTime"
              class="custom-mobile-button"
              @click="stopActivity()"
            >
              {{ $t("WorkRegistrationForm.Stop") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="row">
        <div
        class="col-6"
        >
          <span>{{ $t("WorkRegistrationForm.StartTime") }}</span>
          <div class="div-field">
            <datetime
              v-bind:type="isEnabledMidnightOption() ? 'datetime' : 'time'"
              v-model="selectedStartTime"
              v-bind:format="isEnabledMidnightOption() ? 'dd/HH:mm' : 'HH:mm'"
              input-style="text-align:center"
              class="theme-blue"
              v-bind:backdrop-click="false"
              :min-datetime="isEnabledMidnightOption() ? minDatetime : null"
              :max-datetime="isEnabledMidnightOption() ? maxDatetime : null"
              input-id="inputStartTime"
              @input="onSelectStartTime"
            >
            </datetime>
          </div>
        </div>
        <div class="col-6">
          <span>{{ $t("WorkRegistrationForm.EndTime") }}</span>
          <div class="div-field">
            <datetime
              v-bind:type="isEnabledMidnightOption() ? 'datetime' : 'time'"
              v-model="selectedEndTime"
              v-bind:format="isEnabledMidnightOption() ? 'dd/HH:mm' : 'HH:mm'"
              input-style="text-align:center"
              class="theme-blue"
              v-bind:backdrop-click="false"
              :min-datetime="isEnabledMidnightOption() ? minDatetime : null"
              :max-datetime="isEnabledMidnightOption() ? maxDatetime : null"
            >
            </datetime>
          </div>
        </div>
      </div>
    </div>

    <div>
      <input
        v-model="type"
        class="form-control"
        type="text"
        :placeholder="$t('WorkRegistrationForm.Type')"
        style="margin-top: 10px; margin-bottom: 10px"
        :disabled="true"
      />
      <input
        v-model="rode"
        class="form-control"
        type="text"
        :placeholder="$t('WorkRegistrationForm.Rode')"
        style="margin-top: 10px; margin-bottom: 10px"
      />
    </div>

    <div>
      <button
        v-if="!addTimeManually"
        class="custom-mobile-button"
        @click="enterTimeManually()"
      >
        {{ $t("WorkRegistrationForm.EnterTimeManually") }}
      </button>
      <button class="custom-mobile-button" @click="checkIfWorkDayExists()">
        {{ $t("WorkRegistrationForm.Save") }}
      </button>
      <BackButton />
    </div>
  </div>
</template>
<script>
import LocalStorageService from "../services/LocalStorageService";
import ProjectService from "../services/ProjectService";
import ActivityService from "../services/ActivityService";
import WorkRegistrationService from "../services/WorkRegistrationService";
import { formatDateTimeServer, formatDateServer } from "../utils";
import BackButton from "../components/common/BackButton";
import moment from "moment";
import WorkSlipService from "../services/WorkSlipService";
import WorkDayService from "../services/WorkDayService";

export default {
  name: "AddUnforeseen",
  components: {
    BackButton,
  },
  props: {
    drivers: null,
    workRegistration: null,
    workDate: null,
    workDayEndTime: null,
  },
  workRegistrationService: null,
  activityService: null,
  projectService: null,
  localStorageService: null,
  workSlipService: null,
  workDayService: null,
  data() {
    return {
      showDriverModal: false,
      projects: null,
      selectedProject: null,
      activities: null,
      selectedActivity: null,
      remark: "",
      selectedTime: null,
      selectedRemarks: [],
      remarks: null,
      maxDatetime: null,
      minDatetime: null,
      workDayId: null,
      isWorkSlipEmployee: false,
      employee: null,
      workSlip: null,
      workSlips: null,
      maxWrEndTime: null,
      selectedWorkSlip: null,
      selectedStartTime: null,
      selectedEndTime: null,
      filteredActivities: null,
      showEndTimeDialog: false,
      workDay: null,
      addTimeManually: false,
      moment: moment,
      saveDay: false,
      type: null,
      rode: null,
    };
  },
  created() {
    this.workRegistrationService = new WorkRegistrationService();
    this.activityService = new ActivityService();
    this.projectService = new ProjectService();
    this.localStorageService = new LocalStorageService();
    this.workSlipService = new WorkSlipService();
    this.workDayService = new WorkDayService();
    this.employee = this.localStorageService.getCurrentEmployee();
    this.isWorkSlipEmployee = this.employee.isWorkSlipEmployee;
    this.workDayId = this.$route.query.workDayId;
    this.getProjectInfos();
    this.getActivityInfos();
    this.workDate = this.$route.query.workDate;
    this.selectedActivity = this.activities;
    this.workRegistration = this.$route.query.workRegistration;
    this.addTimeManually = this.$route.query.addTimeManually
      ? this.$route.query.addTimeManually
      : false;
      if(this.workRegistration){
        this.selectedStartTime = this.workRegistration.startTime;
        this.selectedEndTime = this.workRegistration.endTime;
      }
 
    this.rode = this.$route.query.rode
      ? this.$route.query.rode
      : null;
  },
  mounted() {
    this.minDatetime = this.workDate;
    this.maxDatetime = moment(this.workDate)
      .add(1, "days")
      .add(23, "hours")
      .add(59, "minutes")
      .format("YYYY-MM-DD[T]HH:mm:00");
    this.getWorkDay();
  },
  methods: {
    onSelectedDriver(value) {
      this.showDriverModal = false;
      if (value && value.value === true) {
        const description = `Bestuurder: ${value.driver}`;
        this.remark = description;
      }
    },
    getWorkRegistrationMaxEndTime() {
      this.workRegistrationService
        .getWorkRegistrationMaxEndTime(this.workDayId, this.employee.id)
        .then((response) => {
          let self = this;
          self.maxWrEndTime = response.data;
          if (this.workRegistration) {
            this.selectedStartTime = formatDateTimeServer(
              new Date(this.workRegistration.startTime)
            );
            if (this.workRegistration.endTime != null) {
              this.selectedEndTime = formatDateTimeServer(
                new Date(this.workRegistration.endTime)
              );
            } else if(this.addTimeManually){
              this.selectedEndTime = formatDateTimeServer(
                new Date(this.workDayEndTime)
              );
            }
          } else if(this.addTimeManually){
            const hours = new Date().getHours();
            const minutes = new Date().getMinutes();
            const startTime = new Date(this.workDate);
            startTime.setHours(hours);
            startTime.setMinutes(minutes);
            const dummyDate = new Date();
            if (self.maxWrEndTime) {
              this.selectedStartTime = formatDateTimeServer(self.maxWrEndTime);
              // var end = new Date(self.maxWrEndTime);
              // end.setHours(end.getHours() + 1);
              // this.selectedEndTime = formatDateTimeServer(end);
            } else {
              if(dummyDate.getDate() == startTime.getDate()) {
                this.selectedStartTime = formatDateTimeServer(startTime);
              }
              // var proposedEnd = new Date(startTime);
              // proposedEnd.setHours(proposedEnd.getHours() + 1);
              // this.selectedEndTime = formatDateTimeServer(end);
            }
            if(this.isEnabledMidnightOption() && !this.selectedStartTime){
              this.hideStartTime();
            }
          }
        })
        .catch(() => {});
    },
    getWorkSlipOptions() {
      this.workSlipService
        .getWorkSlipOptions(this.workDate)
        .then((response) => {
          const result = response.data;
          if (result) {
            this.workSlips = result;
            if (this.workRegistration) {
              this.selectedWorkSlip = this.workSlips.find(
                (s) => s.value === this.workRegistration.workSlipNumber
              );
            }
          }
        })
        .catch(() => {});
    },
    getProjectInfos() {
      this.projectService
        .getProjectInfos()
        .then((response) => {
          const result = response.data;
          if (result) {
            this.projects = result.map((s) => {
              return {
                id: s.id,
                name: `${s.projectNumber} ${s.name}`,
                isRecent: s.isRecent,
              };
            });
            if (this.workRegistration) {
              this.selectedProject = this.projects.find(
                (s) => s.id === this.workRegistration.projectId
              );
            }
            if (this.isWorkSlipEmployee) this.getWorkSlipOptions();
          }
        })
        .catch(() => {});
    },
    onSelectProject() {
      this.selectedObject = null;
    },
    getActivityInfos() {
      this.activityService
        .getActivityInfos()
        .then((response) => {
          const result = response.data;
          if (result) {
            this.activities = result.map((s) => {
              return {
                id: s.id,
                name: s.name,
                descriptionRequired: s.descriptionRequired,
                remarks: s.remarks,
                defaultProjectId: s.defaultProjectId,
                isRecent: s.isRecent,
                activityCode: s.activityCode,
              };
            });
            if (this.workRegistration) {
              this.selectedActivity = this.activities.find(
                (s) => s.id === this.workRegistration.activityId
              );
              this.remarks = this.selectedActivity.remarks;
              if (this.workRegistration) {
                this.remark = this.workRegistration.activityRemark || "";
                if (this.remark && this.remarks) {
                  this.remarks.forEach((s) => {
                    if (this.remark.indexOf(s.name) > -1) {
                      this.selectedRemarks.push(s);
                    }
                  });
                }
              }
            }
          }
          this.filteredActivities = this.activities.filter((activity) => {
            return activity.activityCode[0] != "1";
          });
          this.selectedActivity = this.activities.find((item) => {
            return item.activityCode == "110.107.02.007";
          });
          this.type = this.selectedActivity.name;
        })
        .catch(() => {});
    },
    onSelectActivity() {
      if (this.selectedActivity.defaultProjectId) {
        this.selectedProject = this.projects.find(
          (s) => s.id === this.selectedActivity.defaultProjectId
        );
      }
      this.remarks = this.selectedActivity.remarks;
      if (this.workRegistration) {
        this.remark = this.workRegistration.activityRemark || "";
        if (this.remark && this.remarks) {
          this.remarks.forEach((s) => {
            if (this.remark.indexOf(s.name) > -1) {
              this.selectedRemarks.push(s);
            }
          });
        }
      }
    },
    isEnabledMidnightOption() {
      let isMidnight = this.$route.query.isMidnight === true || false;
      if (isMidnight === true) return isMidnight;
      return (
        this.localStorageService.getCurrentEmployee().isEnabledMidnightOption ||
        false
      );
    },
    checkIfWorkDayExists() {
      if(this.rode == null || this.rode == "")
        {
          this.$toast.add({
          severity: "warn",
          detail: "Please add a reason.",
          life: 3000,
          closable: false,
        });
          return;
        }
      if (
        !this.selectedStartTime ||
        (this.addTimeManually && document.getElementById("inputStartTime").style[0] == "text-indent")
      ) {
        this.$toast.add({
          severity: "warn",
          detail: "Please select start time.",
          life: 3000,
          closable: false,
        });
        return;
      }
      if (this.workDayId == 0) {
        this.workDayService.createWorkDay(this.workDate).then((response) => {
          this.workDayId = response.data.id;
          this.checkEmployeeType();
        });
      } else {
        this.checkEmployeeType();
      }
    },
    checkEmployeeType() {
      if (this.isWorkSlipEmployee) {
        this.saveWorkRegistration();
      } else {
        for (const wr of this.workDay.workRegistrations) {
          if (
            new Date(this.selectedStartTime).getTime() >=
              new Date(wr.startTime).getTime() &&
            new Date(this.selectedStartTime).getTime() <
              new Date(wr.endTime).getTime()
          ) {
            this.showEndTimeDialog = true;
            //return;
          }
        }
        this.saveWorkRegistration();
      }
    },
    saveWorkRegistration() {
      let startTime = formatDateTimeServer(new Date(this.selectedStartTime));
        // ? formatDateTimeServer(new Date(this.selectedStartTime))
        // : null;
        if(!this.isEnabledMidnightOption()){
          let dummyStartTime = new Date(this.workDay.workDate);
          dummyStartTime.setHours(new Date(this.selectedStartTime).getHours());
          dummyStartTime.setMinutes(new Date(this.selectedStartTime).getMinutes());
          startTime = formatDateTimeServer(new Date(dummyStartTime));
        }
      

      let dummyEndTime = new Date(this.workDay.workDate);
      let endTime = this.selectedEndTime;
      if(this.selectedEndTime && this.selectedEndTime != '' && this.selectedEndTime != 'Invalid date' && !this.isEnabledMidnightOption()){
        dummyEndTime.setHours(new Date(this.selectedEndTime).getHours());
        dummyEndTime.setMinutes(new Date(this.selectedEndTime).getMinutes());
        endTime = formatDateTimeServer(new Date(dummyEndTime));
      } else if(this.selectedEndTime == '' || this.selectedEndTime == 'Invalid date' || !this.selectedEndTime) {
          endTime = null;
        } else {
          endTime = formatDateTimeServer(new Date(this.selectedEndTime));
        }
         if(!this.selectedStartTime){
        this.$toast.add({
          severity: "warn",
          detail: "Please select start time.",
          life: 3000,
          closable: false,
        });
      }
      if (!this.workRegistrationService.validateTimes(formatDateTimeServer(startTime), formatDateTimeServer(endTime))){
        return;
        }
      /*       let endTime = this.isWorkSlipEmployee
        ? formatDateTimeServer(new Date(this.selectedEndTime))
        : this.showEndTimeDialog
        ? formatDateTimeServer(new Date(this.selectedEndTime))
        : null; */
              if(!endTime && this.workDay && this.workDay.workRegistrations && this.workDay.workRegistrations.length > 1){
        var lastWrStartTime = new Date(this.workDay.workRegistrations[this.workDay.workRegistrations.length - 1].startTime).getTime();
        var lastWrEndTime = new Date(this.workDay.workRegistrations[this.workDay.workRegistrations.length - 1].endTime).getTime();
        var firstWrStartTime = new Date(this.workDay.workRegistrations[0].startTime).getTime();
        var currentStartTime = new Date(startTime).getTime();
        if(lastWrEndTime){
          if(currentStartTime < lastWrEndTime && currentStartTime > firstWrStartTime){
            this.$toast.add({
            severity: "warn",
            detail: "Please select an endtime if you want to add a work registration between another work registrations.",
            life: 5000,
            closable: false,
            });
            return;
          }
        }
        else{
          if(currentStartTime < lastWrStartTime && currentStartTime > firstWrStartTime){
            this.$toast.add({
            severity: "warn",
            detail: "Please select an endtime if you want to add a work registration between another work registrations.",
            life: 5000,
            closable: false,
            });
            return;
          }
        }
      }
      this.showEndTimeDialog = false;
      //if (this.workRegistrationService.validateTimes(startTime, endTime)) {
      this.remark = this.type;
      this.remark += " | " + this.rode;
      let remark = `${this.remark.trim()} ${this.selectedRemarks
        .map((s) => s.name)
        .join(" | ")}`;
      const model = {
        projectId: this.selectedProject ? this.selectedProject.id : null,
        activityId: this.selectedActivity.id,
        startTime: startTime,
        endTime: endTime,
        activityRemark: remark,
        isWorkSlipEmployee: this.isWorkSlipEmployee,
        deviceId: this.localStorageService.getDeviceId(),
        workDayId: +this.workDayId,
        workSlipNumber: this.selectedWorkSlip
          ? this.selectedWorkSlip.workSlipNumber
          : null,
        orderNumber: this.selectedWorkSlip
          ? this.selectedWorkSlip.orderNumber
          : null,
      };

      this.loader = this.$loading.show({});
      if (this.workRegistration) {
        model.id = +this.workRegistration.id;
        model.workDayId = this.workRegistration.workDayId;
        this.workRegistrationService
          .updateWorkRegistration(model)
          .then(() => {
            this.loader.hide();
            //if (this.saveDay)
              return this.$router.push({
                name: "work-day",
                query: { workDate: formatDateServer(this.workDate) },
              });
          })
          .catch(() => {
            this.loader.hide();
          });
      } else {
        this.workRegistrationService
          .createWorkRegistration(model)
          .then((response) => {
            this.loader.hide();
            this.workRegistration = response.data;
            //if (this.saveDay)
              return this.$router.push({
                name: "work-day",
                query: { workDate: formatDateServer(this.workDate) },
              });
          })
          .catch(() => {
            this.loader.hide();
          });
      }
      //}
    },
    onSelectWorkSlip() {
      this.remark = "";
      if (!this.selectedWorkSlip) {
        this.filteredActivities = this.activities.filter((activity) => {
          return activity.activityCode[0] != "1";
        });
        this.selectedProject = null;
        return;
      }
      this.selectedProject = this.projects.find(
        (s) => s.id === this.selectedWorkSlip.projectId
      );
      this.selectedActivity = this.activities.find(
        (s) => s.id === this.selectedWorkSlip.activityId
      );
      //this.remark = this.selectedWorkSlip.workType;
      this.filteredActivities = this.activities.filter((activity) => {
        return activity.activityCode[0] == "1";
      });
    },
    getWorkDay() {
      const workDate = formatDateServer(this.workDate);
      if (
        new Date(workDate).getTime() !=
        new Date(new Date().setHours(0, 0, 0, 0)).getTime()
      ) {
        this.addTimeManually = true;
      }
      this.workDayService.getWorkDay(workDate).then((res) => {
        this.workDay = res.data;
        this.getWorkRegistrationMaxEndTime();
      });
    },
    onSelectedEndTime(event) {
      //this.showEndTimeDialog = false;
      this.selectedEndTime = event.value;
      this.saveWorkRegistration();
    },
    startActivity() {
      if(this.rode == null || this.rode == "")
        {
          this.$toast.add({
          severity: "warn",
          detail: "Please add a reason.",
          life: 3000,
          closable: false,
        });
          return;
        }
      this.selectedStartTime = this.getWorkDayWithCurrentTime();
      this.selectedStartTime = moment(this.selectedStartTime).toISOString();
      this.selectedStartTime = formatDateTimeServer(this.selectedStartTime);
      this.checkIfWorkDayExists();
    },
    stopActivity() {
      let currentDate = this.getWorkDayWithCurrentTime();
      if (
        new Date(currentDate).getTime() <=
          new Date(this.selectedStartTime).getTime() &&
        this.selectedStartTime
      ) {
        this.$toast.add({
          severity: "warn",
          detail: "End time must be greater than start time",
          life: 3000,
          closable: false,
        });
      } else {
        this.selectedEndTime = currentDate;
        this.selectedEndTime = moment(this.selectedEndTime).toISOString();
        this.selectedEndTime = formatDateTimeServer(this.selectedEndTime);
        this.checkIfWorkDayExists();
      }
    },
    enterTimeManually() {
      this.addTimeManually = !this.addTimeManually;
      this.getWorkRegistrationMaxEndTime();
    },
    getWorkDayWithCurrentTime() {
      let workDate = new Date(this.workDate);
      workDate.setHours(new Date().getHours());
      workDate.setMinutes(new Date().getMinutes());
      return workDate;
    },
    checkTimes() {
      this.saveDay = true;
      if (
        this.workRegistrationService.validateTimes(
          formatDateTimeServer(this.selectedStartTime),
          formatDateTimeServer(this.selectedEndTime)
        ) &&
        this.selectedStartTime
      ) {
        if(this.rode != null)
        {
          this.checkIfWorkDayExists();
        } else {
          this.$toast.add({
          severity: "warn",
          detail: "Please add a reason.",
          life: 3000,
          closable: false,
        });
        }
      } else {
        this.$toast.add({
          severity: "warn",
          detail: "Please select start time.",
          life: 3000,
          closable: false,
        });
      }
      
    },
    onSelectStartTime() {
      if (document.getElementById("inputStartTime") && document.getElementById("inputStartTime").style[0] == "text-indent")
        document.getElementById("inputStartTime").style = "text-align: center;";
    },
    hideStartTime() {
      if (document.getElementById("inputStartTime") == null) {
         setTimeout(() => this.hideStartTime(), 1000);
      } else {
        this.selectedStartTime = this.minDatetime;
        document.getElementById("inputStartTime").style = "text-indent: -99em;";
      }
    },
  },
};
</script>
<style scoped>
.vdatetime >>> .vdatetime-input {
  width: 50%;
}
.div-field {
  margin-top: 10px;
  width: 100%;
}
.p-listbox {
  width: 100%;
}
.p-listbox-item {
  padding: 10px;
}
.p-inputtextarea {
  width: 100%;
}
.recent {
  color: #019ee9 !important;
}
</style>
